<template>
  <div>
    <span class="txt-link">{{gridItem.ownerNumber}}</span>
    <span>{{' - '}}</span>
    <span>{{gridItem.ownerName}}</span>
    <i v-b-popover.hover.top.html="popoverMethod" title="Primary Contact" class="fa fa-info ml-2"></i>
    <a :href="'mailto:' + this.gridItem.primaryContactEmail">
      <i class="fa fa-envelope ml-2 envelop-color"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: ['gridItem'],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    popoverMethod() {
      const {
        primaryContactName,
        primaryContactEmail,
        PrimaryContactPhone
      } = this.gridItem;

      let popOverHtml = '';

      if (primaryContactName) {
        popOverHtml += '<div>Name: ' + primaryContactName + '</div>';
      }

      if (primaryContactEmail) {
        popOverHtml += '<div>Email: ' + primaryContactEmail + '</div>';
      }

      if (PrimaryContactPhone) {
        popOverHtml += '<div>Phone: ' + PrimaryContactPhone + '</div>';
      }
      // Returns the content as a string
      // Will be called each time the popover is opened
      return popOverHtml;
    }
  }
};
</script>